/*eslint-disable*/

import React from "react";

class Table extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          variable: this.props.variable,
        };
    }

    formatDate(UTCtime){
      const date = new Date(UTCtime);
      return date.getFullYear() + "/" + this.fixTime(date.getMonth()+1) + "/" + this.fixTime(date.getDate());
    }

    formatTime(UTCtime){
      const date = new Date(UTCtime);
      return date.getHours() + ":" + this.fixTime(date.getMinutes()) + ":" + this.fixTime(date.getSeconds());
    }
    round(num){
      return Math.round(num * 100) / 100;
    }

    fixTime(d){
      return ('0' + d).slice(-2);
    }


    componentDidUpdate(prevProps) {
      // Typical usage (don't forget to compare props):
      if (this.props.variable !== prevProps.variable) {
        this.setState({
          variable: this.props.variable,
        })
      }
    }

    getVariableTable(variable){
      switch(variable){
        case "AmbientHumidity":
          return(this.props.store.AmbientHumiditySensor.raw.map((value,index) => (
            <tr key={value.key + index}>
                <td key={"col1" + index} className="text-center">{index +1}</td>
                <td key={"col2" + index}>{this.formatDate(value.timestamp)}</td>
                <td key={"col3" + index}>{this.formatTime(value.timestamp)}</td>
                <td key={"col4" + index}>{value.value}</td>
            </tr>)));
        case "UV":
          return(this.props.store.UVSensor.raw.map((value,index) => (
            <tr key={value.key + index}>
                <td key={"col1" + index} className="text-center">{index+1}</td>
                <td key={"col2" + index}>{this.formatDate(value.timestamp)}</td>
                <td key={"col3" + index}>{this.formatTime(value.timestamp)}</td>
                <td key={"col4" + index}>{value.value}</td>
            </tr>)));
        case "AmbientTemp":
          return(this.props.store.AmbientTempSensor.raw.map((value,index) => (
            <tr key={value.key + index}>
                <td key={"col1" + index} className="text-center">{index+1}</td>
                <td key={"col2" + index}>{this.formatDate(value.timestamp)}</td>
                <td key={"col3" + index}>{this.formatTime(value.timestamp)}</td>
                <td key={"col4" + index}>{value.value}</td>
            </tr>)));
        case "BarometerMoisture":
          return(this.props.store.BarometerMoistureSensor.raw.map((value,index) => (
            <tr key={value.key + index}>
                <td key={"col1" + index} className="text-center">{index +1}</td>
                <td key={"col2" + index}>{this.formatDate(value.timestamp)}</td>
                <td key={"col3" + index}>{this.formatTime(value.timestamp)}</td>
                <td key={"col4" + index}>{value.value}</td>
            </tr>)));
        case "SoilTemp":
          return(this.props.store.SoilTempSensor.raw.map((value,index) => (
            <tr key={value.key + index}>
                <td key={"col1" + index} className="text-center">{index+1}</td>
                <td key={"col2" + index}>{this.formatDate(value.timestamp)}</td>
                <td key={"col3" + index}>{this.formatTime(value.timestamp)}</td>
                <td key={"col4" + index}>{value.value}</td>
            </tr>)));
        case "SoilMoisture":
          return(this.props.store.SoilMoistureSensor.raw.map((value,index) => (
            <tr key={value.key + index}>
                <td key={"col1" + index} className="text-center">{index+1}</td>
                <td key={"col2" + index}>{this.formatDate(value.timestamp)}</td>
                <td key={"col3" + index}>{this.formatTime(value.timestamp)}</td>
                <td key={"col4" + index}>{value.value}</td>
            </tr>)));
        case "BarometerTemp":
          return(this.props.store.BarometerTempSensor.raw.map((value,index) => (
            <tr key={value.key + index}>
                <td key={"col1" + index} className="text-center">{index +1}</td>
                <td key={"col2" + index}>{this.formatDate(value.timestamp)}</td>
                <td key={"col3" + index}>{this.formatTime(value.timestamp)}</td>
                <td key={"col4" + index}>{value.value}</td>
            </tr>)));
        case "WindSpeed":
          return(this.props.store.WindSpeedSensor.raw.map((value,index) => (
            <tr key={value.key + index}>
                <td key={"col1" + index} className="text-center">{index+1}</td>
                <td key={"col2" + index}>{this.formatDate(value.timestamp)}</td>
                <td key={"col3" + index}>{this.formatTime(value.timestamp)}</td>
                <td key={"col4" + index}>{value.value}</td>
            </tr>)));
        case "BarometerPressure":
          return(this.props.store.BarometerPressureSensor.raw.map((value,index) => (
            <tr key={value.key + index}>
                <td key={"col1" + index} className="text-center">{index+1}</td>
                <td key={"col2" + index}>{this.formatDate(value.timestamp)}</td>
                <td key={"col3" + index}>{this.formatTime(value.timestamp)}</td>
                <td key={"col4" + index}>{value.value}</td>
            </tr>)));
        default:
          break;
      }
    }

    render() {
        return (
            <>
              {this.getVariableTable(this.state.variable)}
            </>
        );
    }
}

 export default Table
